/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import 'hammerjs';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
// import posthog from 'posthog-js'

// posthog.init('phc_uvyccVCnLMEerxU4SNkAVTqQ4fbsBvijT3hgIoDtzRl',
//   {
//       api_host: 'https://us.i.posthog.com',
//       // person_profiles: 'identified_only' // or 'always's to create profiles for anonymous users as well
//   }
// )

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
